import Phaser from 'phaser';

export default class BackgroundGradientLinear extends Phaser.Image {
  constructor({ game, startColour, endColour, defaultWidth, defaultHeight, endY, stops }) {
    super(game);

    this.bitmapScale = 0.25;
    this.defaultWidth = defaultWidth || Math.max(this.game.width, this.game.defaultWidth);
    this.defaultHeight = defaultHeight || Math.max(this.game.height, this.game.defaultHeight);
    this.bitmapData = this.game.make.bitmapData(
      this.defaultWidth * this.bitmapScale,
      this.defaultHeight * this.bitmapScale
    );

    this.endY = endY * this.bitmapScale;
    this.setGradient(startColour, endColour, stops);

    this.image = this.game.make.image(0, 0, this.bitmapData);
    this.image.scale.set(1 / this.bitmapScale);

    this.addChild(this.image);

    this.anchor = this.image.anchor;
  }

  setGradient(startColour, endColour, stops) {
    this.startColour = startColour;
    this.endColour = endColour;
    this.stops = stops;
    this.renderGradient();
  }

  renderGradient() {
    this.gradientFill = this.bitmapData.context.createLinearGradient(
      0,
      0,
      0,
      this.endY || this.defaultHeight
    );
    this.gradientFill.addColorStop(0, this.startColour);
    this.gradientFill.addColorStop(1 * this.bitmapScale, this.endColour);
    if (this.stops) {
      for (const { stop, clr } of this.stops) {
        this.gradientFill.addColorStop(stop * this.bitmapScale, clr);
      }
    }

    this.bitmapData.context.fillStyle = this.gradientFill;
    this.bitmapData.context.fillRect(
      0,
      0,
      this.defaultWidth * this.bitmapScale,
      this.defaultHeight * this.bitmapScale
    );

    this.bitmapData.update();
  }

  destroy(destroyChildren = true) {
    this.game.destroyBitmapData(this.bitmapData);
    this.bitmapData = null;
    super.destroy(destroyChildren);
  }
}



// WEBPACK FOOTER //
// ./js/app/games/chase/game/BackgroundGradientLinear.js